import { inject, Injectable } from '@angular/core';
import { UserStore } from '@app/store/user.store';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  username: string | undefined;
  profile?: string;
  userStore = inject(UserStore);

  constructor(private keycloakService: KeycloakService) {
    keycloakService.loadUserProfile().then((res: KeycloakProfile) => {
      this.username = res.firstName + ' ' + res.lastName;
    });
  }

  isAdmin(): boolean {
    return this.userStore.user()?.admin || false;
  }

  logout() {
    this.keycloakService.logout(environment.keycloak.logoutURI).then(() => {});
  }
}
